import { DataLogRq, SourcePage } from '@domain/rq/DataLog';
import ProfilePreferentialFormVO, {
  MilitaryFormVO,
  VeteranFormVO,
  DisabilityFormVO,
} from '@domain/vo/profile/ProfilePreferentialFormVO';
import {
  DisabilityGradeType,
  DisabilityType,
  MilitaryClassType,
  MilitaryDischargeType,
  MilitaryStatusType,
  MilitaryType,
  VeteranStatusType,
} from '@domain/constant/profile/PreferentialType';
import DateFormat from '@utils/date/format';

export default class ProfilePreferentialSaveRq {
  military: MilitaryRq | null;
  disability: DisabilityRq | null;
  veteran: VeteranRq | null;
  sourcePage?: SourcePage;

  constructor(vo: ProfilePreferentialFormVO & DataLogRq) {
    this.military = vo.militaryUseYn && vo.military ? new MilitaryRq(vo.military) : null;
    this.disability = vo.disabilityUseYn && vo.disability ? new DisabilityRq(vo.disability) : null;
    this.veteran = vo.veteranUseYn && vo.veteran ? new VeteranRq(vo.veteran) : null;
    this.sourcePage = vo.sourcePage;
  }
}

export class MilitaryRq {
  status: MilitaryStatusType | null;
  type: MilitaryType | null;
  militaryClass: MilitaryClassType | null;
  dischargeType: MilitaryDischargeType | null;
  startDate: string;
  endDate: string;

  constructor(vo: MilitaryFormVO) {
    this.status = vo.status ? (vo.status.value as MilitaryStatusType) : null;
    this.type = vo.type ? (vo.type.value as MilitaryType) : null;
    this.militaryClass = vo.militaryClass ? (vo.militaryClass.value as MilitaryClassType) : null;
    this.dischargeType = vo.dischargeType ? (vo.dischargeType.value as MilitaryDischargeType) : null;

    this.startDate = this.getDateFormat(vo.startDate);
    this.endDate = this.getDateFormat(vo.endDate);
  }

  getDateFormat(data: string | null) {
    return DateFormat.getDateFormatString(data, 'yyyy-MM') ?? '';
  }
}

export class DisabilityRq {
  grade: DisabilityGradeType | null;
  type: DisabilityType | null;

  constructor(vo: DisabilityFormVO) {
    this.grade = vo.grade ? (vo.grade.value as DisabilityGradeType) : null;
    this.type = vo.type ? (vo.type.value as DisabilityType) : null;
  }
}

export class VeteranRq {
  status: VeteranStatusType | null;
  reason: string | null;

  constructor(vo: VeteranFormVO) {
    this.status = vo.status ? (vo.status.value as VeteranStatusType) : null;
    this.reason = vo.reason ? vo.reason.trim() : null;
  }
}
